import { Link } from "react-router";

export function Header() {
  return (
    <header
      className="flex lg:hidden items-center fixed z-10 top-0 start-0 end-0 shrink-0 bg-[--tw-page-bg] dark:bg-[--tw-page-bg-dark] h-[--tw-header-height]"
      id="header"
    >
      <div className="container-fixed flex items-center justify-between flex-wrap gap-3">
        <Link to="/">
          <img
            alt=""
            className="dark:hidden min-h-[30px]"
            src="/media/logos/enos-logo-small.svg"
          />
          <img
            alt=""
            className="hidden dark:block min-h-[30px]"
            src="/media/logos/enos-logo-small.svg"
          />
        </Link>
        <button
          className="btn btn-icon btn-light btn-clear btn-sm -me-2"
          data-drawer-toggle="#sidebar"
        >
          <i className="ki-filled ki-menu"></i>
        </button>
      </div>
    </header>
  );
}
